import gql from 'graphql-tag'

export default gql`
mutation updateParking ($id: Int!, $input: ParkingInput) {
  updateParking (id: $id, input: $input) {
    id
  }
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/parking/update.js